import { ChangeDetectionStrategy, Component, computed, effect, input, signal, viewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatChipOption } from '@angular/material/chips';
import { MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { MatMenuTrigger } from '@angular/material/menu';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';
import { selectTranslatedKey } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { i18nKeys } from '@src/suite/common/utils/i18n.default';
import { optionContainsTerm } from '@src/suite/common/utils/util';
import { Observable } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'st-status',
    templateUrl: './status.html',
    styleUrls: ['./status.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-status',
    },
})
export class StatusComponent extends EnpsControlComponent<string> {
    // protected _value: string;
    // @Input()
    // public get value(): string {
    //     return this._value?.replace(/[\u00A0]/g, ' ');
    // }
    // public set value(v: string) {
    //     this._value = v;
    //     this.internalValue = v ? [v] : [];
    // }

    menuTrigger = viewChild(MatMenuTrigger);
    selectionList = viewChild(MatSelectionList);
    statusChip = viewChild(MatChipOption);

    value = input<any, string>('', {
        transform: (value: string) => {
            return value?.replace(/[\u00A0]/g, ' ');
        },
    });
    internalValue = signal<string[]>(null);
    itemList = input<Array<{ id: string; title: string }>>([]);
    statusFilter = new FormControl('');
    filteredOptions: Observable<string[]>;

    displayValue = computed(() => {
        return this.internalValue()?.length ? this.getItemStatusLabel(this.internalValue()?.[0]) : this.placeholder();
    });

    webSearchLabel = computed(() => {
        return this.store.selectSignal(selectTranslatedKey(i18nKeys.PSTWebSearchLabel))();
    });

    constructor() {
        super();
        effect(
            () => {
                this.internalValue.set(this.value() ? [this.value()] : []);
            },
            { allowSignalWrites: true }
        );
    }

    private _filter(value: string): string[] {
        return this.itemList()
            .filter(option => optionContainsTerm(option.id, value) || optionContainsTerm(option.title, value))
            .map(item => item.id);
    }

    getItemStatusLabel(item: any) {
        return this.itemList().find(i => i.id === item)?.title;
    }

    internalValueChanged(event: MatSelectionListChange) {
        this.isValueChanged.set(true);
        this.internalValue.set([event.options[0].value]);
    }

    valueChanged() {
        if (this.isValueChanged()) {
            this.isValueChanged.set(false);
            this.changed.emit(this.internalValue()[0]);
        }
        this.statusFilter.setValue('');
    }

    onMenuOpened(): void {
        super.onMenuOpened();
        this.filteredOptions = this.statusFilter.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '')),
            takeUntil(this.destroyed$)
        );
    }

    openMatMenu() {
        if (!this.menuTrigger().menuOpen) {
            this.menuTrigger().openMenu();
        }
    }

    onUpArrowPress() {
        this.selectionList()?.options?.last?.focus();
    }

    onDownArrowPress() {
        this.selectionList()?.options?.first?.focus();
    }

    onTabOrEscPress() {
        this.statusChip().focus();
    }
}
